module.exports = __webpack_public_path__ + "static/media/flat-tire-csm.c48cebc5.png";